import { useInvitations } from '@melio/platform-api';

export const usePendingInvitations = () => useInvitations({ params: { status: 'pending' } });
